export const ratings= [
    {lower_rating:0.0, higher_rating: 1.0},
    {lower_rating:1.1, higher_rating: 2.0},
    {lower_rating:2.1, higher_rating: 3.0},
    {lower_rating:3.1, higher_rating: 4.0},
    {lower_rating:4.1, higher_rating: 5.0},
    {lower_rating:5.1, higher_rating: 6.0},
    {lower_rating:6.1, higher_rating: 7.0},
    {lower_rating:7.1, higher_rating: 8.0},
    {lower_rating:8.1, higher_rating: 9.0},
    {lower_rating:9.1, higher_rating: 10.0}
]